export enum backGroundEnum {
  '/' = 'page-home',
  '/contacto-hola' = 'bkg-blue',
  '/contacto-proyecto' = 'bkg-red',
  '/contacto-trabajo' = 'bkg-purple',
  '/politica-proteccion-datos' = 'page-legal',
  '/404-not-found' = 'page-home',
  '/aviso-legal' = 'page-legal'
}
